const isEmpty = require('lodash').isEmpty
const constants = require('./constants')

/**
 * Get the paths of a Certificate 
 * 
 * @param {String} reportId UserHikeReport ID
 * @param {String} uuid User uuid
 * @returns {Object} {
 *  prefix: Prefix in S3
 *  filename: Certificate filemame
 *  path: The file path in S3
 * }
 */
const getCertificatePaths = (reportId, uuid) => {
    if (isEmpty(reportId) || isEmpty(uuid)) {
        return false
    }

    reportId = String(reportId)
    uuid = String(uuid)

    const prefix = `cert/${uuid}/${reportId}/`
    const filename = 'certificate.pdf'
    return {
        prefix,
        filename,
        path: prefix+filename
    }
}

/**
 * Get the cookie name for access token in LifeHikes SSO
 * 
 * @param {String} env 
 * @returns String|false
 */
const getAccessTokenCookieName = (env = 'development') => {

    // Invalid environment, return false
    if (!constants.AVAILABLE_ENVS.includes(env)) {
        return false
    }

    switch (env) {
        case constants.ENV_DEVELOPMENT:
            return 'lh_dev_at'
    
        case constants.ENV_STAGING:
            return 'lh_staging_at'

        case constants.ENV_PRODUCTION:
            return 'lh_at'
    }
}

/**
 * Get the cookie name for refresh token in LifeHikes SSO
 * 
 * @param {String} env 
 * @returns String|false
 */
const getRefreshTokenCookieName = (env = 'development') => {

    // Invalid environment, return false
    if (!constants.AVAILABLE_ENVS.includes(env)) {
        return false
    }

    switch (env) {
        case constants.ENV_DEVELOPMENT:
            return 'lh_dev_rt'
    
        case constants.ENV_STAGING:
            return 'lh_staging_rt'

        case constants.ENV_PRODUCTION:
            return 'lh_rt'
    }
}

module.exports = {
    getCertificatePaths,
    getAccessTokenCookieName,
    getRefreshTokenCookieName
}